module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/vi/5-2c2b49c9ab0a0f4e7e623d026258b6f2.jpg";